import { InputNumber, InputNumberProps } from 'antd';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

const ZeissInputNumber = (props: InputNumberProps, ref: any): any => {
  const { t } = useTranslation();
  const { bordered = true, className, max, ...rest } = props;

  return (
    <InputNumber
      placeholder={`${t('input.placeholder')}`}
      className={`${className} zeiss-reset-inputNumber ${
        bordered ? 'zeiss-input-border-bottom' : ''
      }`}
      style={{ width: '100%' }}
      autoComplete="off"
      // max={max}
      {...rest}
      ref={ref}
    />
  );
};

export default forwardRef(ZeissInputNumber);
